module.exports = __webpack_public_path__ + "img/Loong3.ac9e8cf4.png";